import { Box, IconButton, Stack } from "@mui/material";
import { Minus, Plus } from "@phosphor-icons/react";
import React, { useEffect, useState, useCallback } from "react";
import debounce from "lodash.debounce";

function CartQuantityButtons({
  updateCartQtyMutate,
  cartId,
  customerId,
  currentQty,
  parentId = null,
}) {
  const [quantity, setQuantity] = useState(currentQty || 1);
  useEffect(() => {
  setQuantity(currentQty || 1);
}, [currentQty]);
  // Create the debounced update function
  const debouncedUpdateCartQty = useCallback(
    debounce((newQuantity) => {
      const param = {
        qty: newQuantity,
        cartId,
        customerId,
        parentId,
      };
      updateCartQtyMutate(param);
    }, 500),
    [cartId, customerId, updateCartQtyMutate]
  );

  const increase = () => {
    const newQuantity = quantity + 1;
    setQuantity(newQuantity);

    // Update the cart with debounce for increases
    debouncedUpdateCartQty(newQuantity);
  };

  const decrease = () => {
    const newQuantity = quantity - 1;
    if (newQuantity < 0) return;
    setQuantity(newQuantity);

    // For zero quantity, cancel debounce and update immediately
    if (newQuantity === 0) {
      debouncedUpdateCartQty.cancel();

      const param = {
        qty: 0,
        cartId,
        customerId,
        parentId,
      };
      updateCartQtyMutate(param);
    } else {
      // For non-zero quantities, use debounced update
      debouncedUpdateCartQty(newQuantity);
    }
  };
  return (
    <Stack direction="row" spacing={2} alignItems={"center"}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          decrease();
        }}
        sx={{
          backgroundColor: "#F9F8F8",
          "&:hover": { backgroundColor: "#e0e0e0" },
          width: 32,
          height: 32,
          borderRadius: "4px",
        }}
      >
        <Minus size={24} color="var(--neutral-600)" />
      </IconButton>
      <Box
        sx={{
          width: 32,
          height: 32,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#F9F8F8",
          borderRadius: 1,
          fontWeight: 600,
          borderRadius: "4px",
          fontSize: "16px",
          color: "var(--neutral-black)",
        }}
      >
        {quantity}
      </Box>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          increase();
        }}
        sx={{
          backgroundColor: "#F9F8F8",
          "&:hover": { backgroundColor: "#e0e0e0" },
          width: 32,
          height: 32,
          borderRadius: "4px",
        }}
      >
        <Plus size={24} color="var(--neutral-600)" />
      </IconButton>
    </Stack>
  );
}

export default CartQuantityButtons;
